type Fetcher<T> = () => Promise<T>

let promiseChain: Promise<any> = Promise.resolve()

export const fetchWhenReady = async <T>(fetcher: Fetcher<T>): Promise<T> => {
  promiseChain = promiseChain.then(fetcher)
  return promiseChain
}
